import type { RouteLocationNormalized } from 'vue-router';
import { getJobAvailability } from './services/jobs.service';
import { JOB_UNAVAILABLE } from './routing';
import { useCartStore } from './stores/cart.store';

export async function jobIsAvailableRouteGuard(
  to: RouteLocationNormalized,
) {
  const cartStore = useCartStore();

  if (cartStore.persistedOrderMethod === 'Prepay' || cartStore.persistedOrderMethod === 'Gallery') {
    // Check if we have a jobId parameter (existing behavior)
    const jobIdString = to.params.jobId;
    if (typeof jobIdString === 'string' && jobIdString.length > 0) {
      const parsedJobId = parseInt(jobIdString);

      if (isNaN(parsedJobId)) {
        return;
      }

      try {
        const availability = await getJobAvailability(parsedJobId);

        if (!availability.published || availability.archived) {
          return { name: JOB_UNAVAILABLE, params: { jobId: parsedJobId } };
        }

        if (cartStore.persistedOrderMethod === 'Prepay' && !availability?.prepay?.available) {
          return { name: JOB_UNAVAILABLE, params: { jobId: parsedJobId } };
        } else if (cartStore.persistedOrderMethod === 'Gallery' && !availability?.gallery?.available) {
          return { name: JOB_UNAVAILABLE, params: { jobId: parsedJobId } };
        }
      } catch (error) {
        // If we can't get availability, redirect to unavailable
        return { name: JOB_UNAVAILABLE, params: { jobId: parsedJobId } };
      }
    }
  }
}
